export default "__VITE_ASSET__VPDETM5b__"